import { EntityState, EntityStore, StoreConfig, ActiveState } from '@datorama/akita';
import { PaginationState, Property, AccessControl } from '@lib/state';
import {
  MaintenanceCategory,
  MaintenanceTicket,
  MaintenanceTicketPhoto,
  PriorityOptions,
  TicketStatus,
  CreationSource,
} from './maintenance-ticket.model';
export interface MaintenanceTicketState
  extends EntityState<MaintenanceTicket, MaintenanceTicket['id']>,
    ActiveState<MaintenanceTicket['id']> {
  pagination: PaginationState;
  photos?: MaintenanceTicketPhoto[];
  entryCode?: AccessControl.MaintenanceTicketRoomEntryCodeModel;
  ui: MaintenanceTicketUIState;
}

export interface MaintenanceTicketUIState {
  propertyId?: Property['id'];
  startDate?: Date;
  endDate?: Date;
  status?: TicketStatus;
  assignedTo?: string;
  priority?: PriorityOptions;
  active?: boolean;
  textFilter?: string;
  categories?: MaintenanceCategory[];
  location?: string;
  creationSource?: CreationSource;
  duplicateTickets?: Array<MaintenanceTicket> | null;
  duplicateTicketPaginationState?: PaginationState;
}
@StoreConfig({ name: 'maintenance-tickets', resettable: true, idKey: 'id' })
export class MaintenanceTicketStore extends EntityStore<MaintenanceTicketState> {
  constructor() {
    super({
      ui: {
        status: TicketStatus.Open,
        priority: PriorityOptions.Normal,
        categories: Array<MaintenanceCategory>(),
      },
      pagination: {
        isDone: true,
        continuationToken: undefined,
      },
      entryCode: undefined,
    });
  }
}

export const maintenanceTicketStore = new MaintenanceTicketStore();
